module.exports = __webpack_public_path__ + "static/img/s118.141d35f5.png";